
<div class="to-sign-upload-cntr">

    <form [formGroup]="form">

        <h3 style="font-weight: 600;">Carica un file ZIP con i documenti firmati per procedere con l'ordine.</h3>

        <ct-file-uploader
        #Uploader
        [configuration]="CTFileUploaderConfiguration"></ct-file-uploader>

        <div class="button-cntr">

            <button mat-raised-button color="warn" (click)="close()">Chiudi</button>

            <button mat-raised-button color="accent" (click)="submit()">Carica</button>

        </div>
    
    </form>

</div>